const UUID_REGEX = /^[0-9a-f]{8}-([0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
const INTEGER_REGEX = /^(0|([-]?[1-9][0-9]*))$/i;

export const isNumeric = n => !Array.isArray(n) && n - parseFloat(n) + 1 >= 0;

export const removeSeparators = (nStringArg) => {
  const nString = nStringArg.split('');
  let i = nString.length - 2;
  const commaSet = {};
  let noOfCommaExceptions = 0;
  let expectedNoOfCommaExceptions = 1;
  const IS_DIGIT = /^[0-9]$/;
  while (i >= 0 && IS_DIGIT.test(nString[i])) {
    i -= 1;
  }
  if (nString[i] !== '.') {
    i = nString.length - 4;
    expectedNoOfCommaExceptions = 0;
  }
  while (i >= 0) {
    if (nString[i] === ',') {
      commaSet[i] = true;
    } else {
      noOfCommaExceptions += 1;
    }
    i -= 4;
  }
  if (noOfCommaExceptions !== expectedNoOfCommaExceptions) {
    return nStringArg;
  }
  return nString.filter((c, index) => !commaSet[index]).join('');
};

export const isNumericFormatted = n =>
  isNumeric(n) || (typeof n === 'string' && isNumeric(removeSeparators(n)));

export const isUuid = uuid => typeof uuid === 'string' && UUID_REGEX.test(uuid);
export const isEmpty = (value) => {
  if (typeof value === 'string') {
    return value.length === 0;
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  if (value === null) {
    return true;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return typeof value === 'undefined';
};

export const isNonEmptyString = value => typeof value === 'string' && !isEmpty(value);
export const isAnything = () => true;

export const createCustomPropType = (validatorFunction) => {
  const curriedCustomPropType = isRequired => (props, propName, componentName) => {
    if (isRequired && props[propName] === undefined) {
      return new Error(`Prop "${propName}" supplied to` + ` "${componentName}" is required but it was missing.`);
    }

    if (!validatorFunction(props[propName])) {
      return new Error(`Invalid prop "${propName}" supplied to` +
          ` "${componentName}". Validation failed ${validatorFunction.name}(${JSON.stringify(props[propName])}) returned false.`);
    }
    return null;
  };
  const validator = curriedCustomPropType(false);
  validator.isRequired = curriedCustomPropType(true);
  return validator;
};

export const isIntegerString = n => isNonEmptyString(n) && INTEGER_REGEX.test(n);

export const isNonReductiveNumeric = (n) => {
  if (!isNumeric(n)) {
    return false;
  }

  if (isNonEmptyString(n)) {
    if ((+n).toString() !== n) {
      return false;
    }
  }

  return true;
};
